import countriesApi, { CountriesRequest, CountriesResponse } from '@api/countries'
import { makeLoader } from '@lib/loader'

export const useCountries = makeLoader<CountriesRequest, CountriesResponse>({
  key: 'countries',
  loader: countriesApi.load,
})
